import { type Unsubscribe } from '@reduxjs/toolkit'
import { type RootState, store } from './Store'
// eslint-disable-next-line eqeqeq
const referenceEquals = (a: any, b: any) => a == b

export function subscribe<TStateValue>(
  selector: (state: RootState) => TStateValue,
  changeHandler: (
    value: TStateValue,
    previousValue: TStateValue,
    state: RootState
  ) => void,
  equals: (a: TStateValue, B: TStateValue) => boolean = referenceEquals
): Unsubscribe {
  const previous = { value: undefined as any }
  return store.subscribe(() => {
    const newState = store.getState()
    const newValue = selector(newState)
    const previousValue = previous.value
    previous.value = newValue
    if (!equals(previousValue, newValue))
      changeHandler(newValue, previousValue, newState)
  })
}
